import axios from "axios";
import store from "./index";

export const http = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
    },
});

http.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        let errorResponse = error.response;
        // store.dispatch("slack", {
        //     name: store.getters.userData.email,
        //     err: errorResponse.data.message,
        // });
        if (errorResponse.status === 401) {
            // localStorage.removeItem("vuex");
            // location.reload();
        }
        if (errorResponse.status === 400) {
            // alert("errorResponse.message");
            // alert(errorResponse.message);
        }
        return Promise.reject(error);
    }
);

export const API = {
    login: "api/auth/login",
    banks: "api/banks",
    credit_requests: "api/credits/requests",
    request_credit: "api/credits",
    resendMobileVerification: "api/resend-mobile-verification",
    resendEmailVerification: "api/resend-email-verification",
    getStatistics: "api/user/statistics",
    checkEmail: "api/auth/email-existence",
    logout: "api/logout",
    user: "api/user",
    uploadAvatar: "api/upload-avatar",
    updateUserProperty: "api/user/update-property",
    register: "api/auth/register",
    updateAccount: "api/user/update-profile",
    addresses: "api/address-book",
    countries: "api/countries",
    rates: "api/get-rate",
    archiveShipments: "api/shipment/archive",
    primary_address: "api/address-book/is-basic",
    shipment: "api/request-shipment",
    userShipment: "api/user-shipments",
    verifyMobile: "api/verify-mobile",
    addressbookSearch: "addressbook/search",
    locationValidate: "location/validate",
    getStateSearch: "api/states",
    getCitiesSearch: "api/cities",
    getPostCodeSearch: "api/postcode",
    generateWayBill: "api/shipment/download/label",
    generateCommercialInvoice: "api/generate-commercial-invoice",
    orderDetails: "api/shipment/details",
    pickupRequest: "api/pickup/request",
    editshipment: "api/shipment/update",
    saveInList: "api/template/package",
    saveInContentList: "api/template/content",
    postCode: "api/postcode",
    internationalRate: "api/demo/international-rate",
    domesticRate: "api/demo/domestic-rate",
    hyperPay: "api/payment/get-checkout-id",
    invoiceHyperPay: "api/payment/invoice/get-checkout-id",
    store_transaction: "api/payment/store-transaction",
    invoice_store_transaction: "api/payment/invoice/store-transaction",
    forgetPassword: "api/auth/forget-password",
    resetPassword: "api/auth/reset-password",
    check_credit: "api/user/checkout-options?order_id=",
    payWithCredit: "api/payment/process-shipment?order_id=",
    transactions: "api/user/transactions",
    invoices: "api/invoice",
    total_due_amount: "api/invoice/total-due",
    invoice: "api/invoice/details/",
    Group_Invoice: "api/invoice/groups/details/",
    shipmentInvoiceDetails: "/api/invoice/shipment/",
};
